import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { translate } from 'react-i18next';

import css from '../../styles/table/table';

class Table extends Component {
    static propTypes = {
        className: PropTypes.string,
        children: PropTypes.node.isRequired,
        headings: PropTypes.arrayOf(PropTypes.oneOfType([
            PropTypes.string,
            PropTypes.shape({
                id: PropTypes.string,
                title: PropTypes.string,
                callback: PropTypes.func,
            }),
        ])),
        t: PropTypes.func.isRequired,
    };

    static defaultProps = {
        headings: ['', 'last', 'change', 'percentChange'],
        className: css.table,
    };

    renderHeadings() {
        const { headings, t } = this.props;

        return (
            <tr>
                {headings.map((heading, key) => {
                    if (typeof heading === 'object') {
                        return (
                            <th
                                key={ key }
                                className={ [heading.className, css.th].join(' ') || css.th }
                                onClick={ heading.callback }
                            >
                                <span>{ t(heading.title) }</span>
                            </th>
                        );
                    }

                    return (
                        <th key={ key } className={ css.th }>
                            <span>{ t(heading) }</span>
                        </th>
                    );
                })}
            </tr>
        );
    }

    render() {
        return (
            <div className={ css.container }>
                <table className={ this.props.className }>
                    <thead className={ css.thead }>
                        { this.renderHeadings() }
                    </thead>
                    <tbody className={ css.tbody }>
                        { this.props.children }
                    </tbody>
                </table>
            </div>
        );
    }
}

export default translate('common')(Table);



/** WEBPACK FOOTER **
 ** /src/shared/components/table/Table.js
 **/